// Lodash
import _join from 'lodash/join';
import _compact from 'lodash/compact'; // Constants

import { EMPTY_OBJECT } from 'tbase/app.constants'; // Readers

import accountReader from 'tbase/readers/Account';

var getAccountLabel = function getAccountLabel() {
  var account = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var accountName = accountReader.accountName(account);
  var accountNumber = accountReader.accountNumber(account);

  if (!(accountName || accountNumber)) {
    return undefined;
  }

  var accountAttributes = [accountNumber, accountName];

  var compactAccountAttributes = _compact(accountAttributes);

  return _join(compactAccountAttributes, ' - ');
};

export default getAccountLabel;